module.exports = __webpack_public_path__ + "static/img/9.f142efb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/9.png
// module id = 9RHK
// module chunks = 0